import { gql } from '@apollo/client';

export const HIDE_TESTER = gql`
mutation HideTester($testerId: ID!) {
  hideTester(testerId: $testerId) {
    tester{
      id
      hidden
    }
  }
}
`;
